export const setupAdvisorModal = ($) => {
  $('#advisor-modal').modaal({
    type: 'confirm',
    overlay_opacity: '0.6',
    confirm_button_text: 'I am a financial professional',
    confirm_cancel_button_text: 'Go back',
    confirm_title: 'This website is intended for financial professional use only',
    accessible_title: 'This website is intended for financial professional use only',
    confirm_content: '',
    close_aria_label: 'Close (Select an option)',
    confirm_callback: function () {
      window.location.href = '/advisor';
    },
    confirm_cancel_callback: function () {
      //
    },
  });

  $('#advisor-modal-institutional').modaal({
    type: 'confirm',
    overlay_opacity: '0.6',
    confirm_button_text: 'I am a financial professional',
    confirm_cancel_button_text: 'Go back',
    confirm_title: 'This website is intended for financial professional use only',
    accessible_title: 'This website is intended for financial professional use only',
    confirm_content: '',
    close_aria_label: 'Close (Select an option)',
    confirm_callback: function () {
      window.location.href = 'https://www.bannerlife.com/advisor';
    },
    confirm_cancel_callback: function () {
      //
    },
  });

  if ($('html.sfPageEditorWrp').length === 0) {
    $('#advisor-modal-content').modaal({
      type: 'inline',
      overlay_opacity: '0.6',
      start_open: true,
      content_source: '#advisor-modal-content',
    });
  }
};
